import { useLoader } from "@/context/loaderContext";
import React, { useEffect, useState } from "react";
import { useToast } from "../toast";
import api from "@/components/customAxios/Axios";

const OrganizationProfile = () => {
	const { setLoading } = useLoader();
	const toast = useToast();
	const [companyData, setcompanyData] = useState({
		name: "",
		address: "",
		email: "",
		phoneNumber: "",
		gstNumber: "",
	});

	const userRole = localStorage.getItem("role");
	const isReadOnly = userRole === "Talentick_user" || userRole === "bluetick-admin";

	const handleCompanyDataChange = (
		e:
			| React.ChangeEvent<HTMLInputElement>
			| React.ChangeEvent<HTMLTextAreaElement>
	) => {
		if (isReadOnly) return;
		const { name, value } = e.target;
		setcompanyData((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	const getCompanyDetails = async () => {
		try {
			setLoading(true);
			const userID = localStorage.getItem("user");
			const response = await api.get(`/get_company_details?id=${userID}`);
			if (response.status === 200) {
				setcompanyData({
					name: response.data.company.name,
					address: response.data.company.address,
					email: response.data.company.email,
					phoneNumber: response.data.company.phone,
					gstNumber: response.data.company.gst_no,
				});
			}
		} catch (error: any) {
			toast.error({
				type: "background",
				duration: 5000,
				status: "error",
				title: "Error Updating Profile",
				description: error.response?.data?.error || error.response?.data?.message || "Failed to fetch company details. Please try again.",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getCompanyDetails();
	}, []);

	const updateOrganization = async () => {
		if (isReadOnly) return;
		try {
			setLoading(true);
			const response = await api.put("/update_company_details", {
				name: companyData.name,
				address: companyData.address,
				email: companyData.email,
				phoneNumber: companyData.phoneNumber,
				gst_no: companyData.gstNumber,
			});

			if (response.status === 200) {
				toast.success({
					type: "background",
					duration: 3000,
					status: "Success",
					title: "Your organization profile has been updated successfully.",
					description: "",
					open: true,
				});
			}
		} catch (error: any) {
			toast.error({
				type: "background",
				duration: 5000,
				status: "error",
				title: "Error Updating Profile",
				description: error.response?.data?.error || error.response?.data?.message || "Failed to update organization profile. Please try again.",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="">
			<label className="block text-lg font-medium text-gray-400 mb-3">
				Organization Profile
			</label>
			<div className=" w-[90%]">
				<div>
					<label className="block  font-medium text-gray-400 mb-2">
						Organization Name
					</label>
					<input
						value={companyData.name}
						onChange={(e) => handleCompanyDataChange(e)}
						name="name"
						type="text"
						required
						readOnly={isReadOnly}
						placeholder="Organization Name"
						className={`w-full border rounded-lg py-2 px-3 text-zinc-700 dark:text-zinc-300 bg-transparent ${isReadOnly ? 'cursor-not-allowed opacity-70' : ''}`}
					/>
				</div>

				<div className="mt-3">
					<label className="block  font-medium text-gray-400 mb-2">
						Address
					</label>
					<textarea
						value={companyData.address}
						onChange={(e) => handleCompanyDataChange(e)}
						name="address"
						rows={3}
						autoComplete="address"
						required
						readOnly={isReadOnly}
						placeholder="Address"
						className={`w-full border rounded-lg py-2 px-3 text-zinc-700 dark:text-zinc-300 bg-transparent ${isReadOnly ? 'cursor-not-allowed opacity-70' : ''}`}
					/>
				</div>
				<div className="grid md:grid-cols-2 gap-4">
					<div className="mt-3">
						<label className="block  font-medium text-gray-400 mb-2">
							Organization Email
						</label>
						<input
							value={companyData.email}
							onChange={(e) => handleCompanyDataChange(e)}
							name="email"
							type="email"
							autoComplete="email"
							required
							readOnly={isReadOnly}
							placeholder="Email"
							className={`w-full border rounded-lg py-2 px-3 text-zinc-700 dark:text-zinc-300 bg-transparent ${isReadOnly ? 'cursor-not-allowed opacity-70' : ''}`}
						/>
					</div>
					<div className="mt-3">
						<label className="block  font-medium text-gray-400 mb-2">
							Phone Number
						</label>
						<input
							value={companyData.phoneNumber}
							onChange={(e) => handleCompanyDataChange(e)}
							name="phoneNumber"
							type="number"
							required
							readOnly={isReadOnly}
							placeholder="0123456789"
							className={`w-full border rounded-lg py-2 px-3 text-zinc-700 dark:text-zinc-300 bg-transparent ${isReadOnly ? 'cursor-not-allowed opacity-70' : ''}`}
						/>
					</div>
				</div>
				<div className="mt-3">
					<label className="block  font-medium text-gray-400 mb-2">
						GST Number
					</label>
					<input
						value={companyData.gstNumber}
						onChange={(e) => handleCompanyDataChange(e)}
						name="gstNumber"
						type="text"
						required
						readOnly={isReadOnly}
						placeholder="Organization GST Number"
						className={`w-full border rounded-lg py-2 px-3 text-zinc-700 dark:text-zinc-300 bg-transparent ${isReadOnly ? 'cursor-not-allowed opacity-70' : ''}`}
					/>
				</div>
				<div className="flex justify-end gap-5 items-center mt-4">
					<div>
						<button
							className={`bg-[#BDE4C3] text-[#438437] px-3 py-1 rounded ${isReadOnly ? 'cursor-not-allowed opacity-70' : ''}`}
							onClick={updateOrganization}
							disabled={isReadOnly}
						>
							Update
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default OrganizationProfile;
